// extracted by css-extract-rspack-plugin
export default {"cls1":"Avatar-cls1_eA7","cls2":"Avatar-cls2_8oE Avatar-cls1_eA7"};